import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { Stack as a, Typography as n, Box as c, Button as u } from "@mui/material";
import { useRef as S } from "react";
import { useStudent as g } from "../../helpers/index.js";
import { h as y } from "../../files-zqKMkTpV.js";
import { formatMoney as m } from "../../helpers/strings.js";
import { useSchool as D } from "../../context/school/index.js";
const C = ({ FormID: e, RowID: t, Amount: l, Fee: d, StudentID: v, Paid: h, Comment: p }) => {
  const { schoolName: s } = D(), o = g(v), f = S(null), x = async () => {
    await y(f.current, "Invoice");
  };
  return /* @__PURE__ */ r(a, { spacing: 2, p: 3, children: [
    /* @__PURE__ */ r(a, { spacing: 2, p: 3, children: [
      /* @__PURE__ */ i(n, { variant: "h3", children: "Tax Invoice" }),
      /* @__PURE__ */ r(c, { children: [
        /* @__PURE__ */ i(n, { variant: "caption", children: "Date paid" }),
        /* @__PURE__ */ i(n, { children: h.toDateString() })
      ] }),
      /* @__PURE__ */ r(c, { children: [
        /* @__PURE__ */ i(n, { variant: "caption", children: "Invoice #" }),
        /* @__PURE__ */ r(n, { children: [
          e,
          ".",
          t
        ] })
      ] }),
      /* @__PURE__ */ r(n, { children: [
        m((l + (d || 0)) / 100),
        " paid to ",
        s
      ] }),
      /* @__PURE__ */ i(n, { children: p }),
      /* @__PURE__ */ r(c, { children: [
        /* @__PURE__ */ i(n, { variant: "caption", children: "Student" }),
        /* @__PURE__ */ i(n, { children: o == null ? void 0 : o.DisplaynameSurname })
      ] })
    ] }),
    /* @__PURE__ */ r(a, { spacing: 2, p: 3, ref: f, sx: { position: "absolute", left: "-9999px", top: "-9999px", backgroundColor: "#fff", color: "#000" }, children: [
      /* @__PURE__ */ i(n, { variant: "h3", children: "Tax Invoice" }),
      /* @__PURE__ */ r(c, { children: [
        /* @__PURE__ */ i(n, { variant: "caption", sx: { color: "#000" }, children: "Date paid" }),
        /* @__PURE__ */ i(n, { children: h.toDateString() })
      ] }),
      /* @__PURE__ */ r(c, { children: [
        /* @__PURE__ */ i(n, { variant: "caption", sx: { color: "#000" }, children: "Invoice #" }),
        /* @__PURE__ */ r(n, { children: [
          e,
          ".",
          t
        ] })
      ] }),
      /* @__PURE__ */ r(n, { children: [
        m((l + (d || 0)) / 100),
        " paid to ",
        s
      ] }),
      /* @__PURE__ */ i(n, { children: p }),
      /* @__PURE__ */ r(c, { children: [
        /* @__PURE__ */ i(n, { variant: "caption", sx: { color: "#000" }, children: "Student" }),
        /* @__PURE__ */ i(n, { children: o == null ? void 0 : o.DisplaynameSurname })
      ] })
    ] }),
    /* @__PURE__ */ i(u, { variant: "contained", onClick: x, children: "Download" })
  ] });
};
export {
  C as Invoice
};
//# sourceMappingURL=Invoice.js.map
